<app-common-loader></app-common-loader>
<router-outlet></router-outlet>
